<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fa fa-code-branch"></i>  {{ "LABEL.WORKFLOW" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="workflowform">
      <div class="form-group" *ngIf="hasRole(ROLE_SUPERADMIN)">
        <label>{{ "LABEL.PARTNER" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fa fa-university" aria-hidden="true"></i></div>
          </div>
          <select class="form-control ml-1 custom-width-select"
                  [(ngModel)]="partnerSelected"
                  (ngModelChange)="reloadEnterprises()"
                  formControlName="partner">
            <option *ngFor="let partner of partners" [ngValue]="partner">{{partner.name | translate}}</option>
          </select>
        </div>
      </div>
      <div class="form-group" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
        <label for="enterpriseInput">{{ "LABEL.ENTERPRISE" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fa fa-building" aria-hidden="true"></i></div>
          </div>
          <select id="enterpriseInput"
                  class="form-control"
                  formControlName="enterprise"
                  [(ngModel)]="workflow.enterpriseId">
            <option *ngFor="let enterprise of enterprises"
                    [ngValue]="enterprise.id">{{enterprise.name | translate}}</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label for="workflowtypeInput">{{ "LABEL.TYPE" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-stream"></i></div>
          </div>
          <select id="workflowtypeInput"
                  class="form-control"
                  formControlName="workflowtype"
                  [(ngModel)]="workflow.type"
                  (change)="reloadWorkflowOptions()">
            <option *ngFor="let workflowtype of workflowtypes"
                    [ngValue]="workflowtype.id">{{'SELECT.OPTIONS.' + workflowtype.description | translate}}</option>
          </select>
        </div>
      </div>
      <div *ngIf="hasAuthority('own:view:workflow:10200')">
        <div class="row">
          <div class="col">
            <label class="font-weight-bold">{{ "LABEL.TYPE-SIGNATURE-ASSIGNMENT" | translate }}</label>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-4">
            <div class="custom-control custom-checkbox my-1 mr-sm-2">
              <input type="checkbox"
                     class="custom-control-input"
                     id="dynamic"
                     formControlName="dynamic"
                     [(ngModel)]="checkedDynamically"
                     (ngModelChange)="onAssignmentTypeChange()"
                     [attr.disabled]="onlySignatureOptionSelected ? null : ''">
              <label class="custom-control-label" for="dynamic">{{ "LABEL.DYNAMIC" | translate }}</label>
            </div>
          </div>
          <div class="col">
            <div class="custom-control custom-checkbox my-1 mr-sm-2">
              <input type="checkbox"
                     class="custom-control-input"
                     id="signFreely"
                     formControlName="freelySignature"
                     [(ngModel)]="checkedSignFreely"
                     (ngModelChange)="onAssignmentSignFreely($event)"
                     [attr.disabled]="disableToOptionSelected ? '' : null">
              <label class="custom-control-label" for="signFreely">{{ "LABEL.FREE" | translate }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <label class="font-weight-bold">{{ "LABEL.DOCUMENT-UPLOAD-OPTION" | translate }}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="custom-control custom-radio">
            <input type="radio"
                   id="loadOne2OneRadio"
                   name="groupRadio"
                   [value]="0"
                   class="custom-control-input"
                   formControlName="groupRadio"
                   [attr.disabled]="selectedAssignmentDynamically ? '' : null"
                   [(ngModel)]="workflow.batch"
                   (ngModelChange)="setUpMaxParticipants()">
            <label class="custom-control-label" for="loadOne2OneRadio">{{ "LABEL.ONE-TO-ON" | translate }}</label>
          </div>
        </div>
        <div class="col" *ngIf="hasAuthority('own:view:workflow:10201')">
          <div class="custom-control custom-radio">
            <input type="radio"
                   id="loadBatchRadio"
                   name="groupRadio"
                   [value]="1"
                   class="custom-control-input"
                   formControlName="groupRadio"
                   [attr.disabled]="selectedAssignmentDynamically || isNotcerWorkflowType || isUploadWorkflowType || SNWithTemplateWorkflowType ? '' : null"
                   [(ngModel)]="workflow.batch"
                   (ngModelChange)="setUpMaxParticipants()">
            <label class="custom-control-label" for="loadBatchRadio">{{ "LABEL.IN-BATCH" | translate }}</label>
          </div>
        </div>
      </div>
      <div class="form-row mt-3">
        <div class="form-group col-md-9">
          <label for="description">{{ "LABEL.FLOW-NAME" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fas fa-keyboard"></i></div>
            </div>
            <input id="description"
                   class="form-control"
                   [(ngModel)]="workflow.description"
                   formControlName="description">
          </div>
        </div>
        <small *ngIf="isInvalidControl('description')"
               class="text-danger">
          {{ "MESSAGE.ENTER-FLOW-NAME" | translate }}
        </small>
        <div class="form-group col-md-3">
          <label for="participants">{{ "LABEL.PARTICIPANTS" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fas fa-sort-numeric-up"></i></div>
            </div>
            <input id="participants"
                   class="form-control"
                   type="number"
                   [(ngModel)]="workflow.maxParticipants"
                   formControlName="maxParticipants"
                   [attr.disabled]="selectedAssignmentDynamically || SNWithTemplateWorkflowType || isNotcerWorkflowType ? '' : null"
                   [class.is-invalid]="isInvalidControl('maxParticipants')">
          </div>
          <small *ngIf="isInvalidControl('maxParticipants')"
                 class="text-danger">
            {{ "MESSAGE.ENTER-PARTICIPANTS" | translate }}
          </small>
        </div>
      </div>
      <div class="form-row mt-0" *ngIf="hasAuthority('own:view:workflow:10202')">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="completionAlertChargeCheck"
                 formControlName="completionAlertCharge"
                 [(ngModel)]="checkedCompletionAlertCharge"
                 (ngModelChange)="addCompletionAlertCharge($event)">
          <label class="custom-control-label"
                 for="completionAlertChargeCheck"
                 [ngbTooltip]="tipUploader">
            {{ "MESSAGE.ALERTING-THE-UPLOADER-WHEN-DOCUMENT-FINISHED" | translate }} </label>
        </div>
      </div>
      <div class="form-row mt-0"
           *ngIf="!isUploadWorkflowType && hasAuthority('own:view:workflow:10203')">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="notificationByDocumentCheck"
                 formControlName="notificationByDocument"
                 [(ngModel)]="checkedNotificationByDocument"
                 (ngModelChange)="addNotificationByDocument($event)">
          <label class="custom-control-label"
                 for="notificationByDocumentCheck"
                 [ngbTooltip]="tipDelivery">
            {{ "MESSAGE.SEND-THE-FINISHED-DOCUMENT-TO-REGISTERED-ADDRESSES" | translate }}</label>
        </div>
      </div>
      <div class="form-row mt-0"
           *ngIf="!isUploadWorkflowType && !isNotcerWorkflowType && hasAuthority('own:view:workflow:10205')">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="extractCoordinatesCheck"
                 formControlName="extractCoordinates"
                 [(ngModel)]="checkedExtractCoordinates"
                 (ngModelChange)="addExtractCoordinates($event)">
          <label class="custom-control-label"
                 for="extractCoordinatesCheck"
                 [ngbTooltip]="tipExtractParam">
            {{ "MESSAGE.EXTRACT-COORDINATES-FROM-LOADED-DOC" | translate }}</label>
        </div>
      </div>
      <div class="form-row mt-0" *ngIf="isSignatureWorkflowType && !isUploadInBatch">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="manageDocumentChecked"
                 formControlName="manageDocumentChecked"
                 (ngModelChange)="onManageDocument($event)">
          <label class="custom-control-label"
                 for="manageDocumentChecked"
                 [ngbTooltip]="tipManegeDocumentChecked">
            {{ "MESSAGE.MANAGE-DOCUMENT" | translate }}</label>
        </div>
      </div>
      <div class="form-row mt-0" *ngIf="isSignatureWorkflowType && !isUploadInBatch">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="cancellationAlertReviewer"
                 formControlName="cancellationAlertReviewer"
                 [(ngModel)]="checkedCancellationAlertReviewer"
                 (ngModelChange)="addCancellationAlertReviewers($event)">
          <label class="custom-control-label"
                 for="cancellationAlertReviewer"
                 [ngbTooltip]="tipCancellationAlertReviewerChecked">
            {{ "MESSAGE.CANCELLATION-ALERT-REVIEWER" | translate }}</label>
        </div>
      </div>
      <div class="form-row mt-0" *ngIf="isSignatureWorkflowType && !isUploadInBatch">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="documentSelection2SignCheck"
                 formControlName="documentSelection2Sign"
                 [(ngModel)]="checkedDocumentSelection2Sign"
                 (ngModelChange)="addDocumentSelection2Sign($event)">
          <label class="custom-control-label"
                 for="documentSelection2SignCheck"
                 [ngbTooltip]="tipDocumentSelection2SignChecked">
            {{ "MESSAGE.DOCUMENT-SELECTION-TO-SIGN" | translate }}</label>
        </div>
      </div>

      <div class="form-row mt-0" *ngIf="isSignatureWorkflowType && !isUploadInBatch">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="checkedExternalDocument"
                 formControlName="checkedExternalDocument"
                 [(ngModel)]="checkedGetExternalDocument">
          <label class="custom-control-label"
                 for="checkedExternalDocument"
                 [ngbTooltip]="tipCheckGetExternalDocument">
            {{ "MESSAGE.EXTERNAL-DOCUMENT" | translate }}</label>
        </div>
      </div>

      <div>
        <div class="form-row mt-0" *ngIf="isSignatureWorkflowType && !isUploadInBatch">
          <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
            <input type="checkbox"
                   class="custom-control-input"
                   id="uploadDocument2Workflow"
                   formControlName="uploadDocument2Workflow"
                   [(ngModel)]="checkedUploadDocument2Workflow"
                   (ngModelChange)="addUploadDocument2Workflow($event)">
            <label class="custom-control-label"
                   for="uploadDocument2Workflow"
                   [ngbTooltip]="tipUploadDocument2workflowChecked">
              {{ "MESSAGE.UPLOAD-DOCUMENT-TO-WORKFLOW" | translate }}</label>
          </div>
        </div>
        <div class="form-row mt-0" *ngIf="isSignatureWorkflowType">
          <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
            <input type="checkbox"
                   class="custom-control-input"
                   id="certifyDocument"
                   formControlName="checkedCertifyDocument"
                   [(ngModel)]="checkedCertifyDocument">
            <label class="custom-control-label"
                   for="certifyDocument"
                   [ngbTooltip]="tipCertifyDocumentChecked">
              {{ "MESSAGE.CERTIFY-DOCUMENT" | translate }}</label>
          </div>
        </div>
        <div class="form-row mt-0" *ngIf="isSignatureWorkflowType">
          <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
            <input type="checkbox"
                   class="custom-control-input"
                   id="checkedManifestDocument"
                   formControlName="checkedAddManifest"
                   [(ngModel)]="checkedAddManifest"
                   (ngModelChange)="isCheckedAddMenifest($event)"
                   [attr.disabled]="SNWithTemplateWorkflowType ? '' : null">
            <label class="custom-control-label"
                   for="checkedManifestDocument"
                   [ngbTooltip]="tipManifest">
              {{ "MESSAGE.CHECKED-ADD-MANIFEST" | translate }}</label>
          </div>
        </div>
        <div class="form-row mt-0" *ngIf="isSignatureWorkflowType">
          <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
            <input type="checkbox"
                   class="custom-control-input"
                   id="checkedAddTraceabilityDocument"
                   formControlName="checkedAddTraceability"
                   [(ngModel)]="checkedAddTraceability"
                   (ngModelChange)="isCheckedAddTraceability($event)"
                   [attr.disabled]="SNWithTemplateWorkflowType ? '' : null">
            <label class="custom-control-label"
                   for="checkedAddTraceabilityDocument"
                   [ngbTooltip]="tipTraceability">
              {{ "MESSAGE.CHECKED-ADD-TRACEABILITY" | translate }}</label>
          </div>
        </div>
        <!--      Evitar duplicados de asuntos de documento-->
        <div class="form-row mt-0" *ngIf="isSignatureWorkflowType">
          <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
            <input type="checkbox"
                   class="custom-control-input"
                   id="preventDuplicateSubjectCheck"
                   formControlName="checkedPreventDuplicateSubject">
            <label class="custom-control-label"
                   for="preventDuplicateSubjectCheck"
                   [ngbTooltip]="preventDuplicateSubject">
              {{ 'MESSAGE.DUPLICATE-SUBJECT' | translate}}</label>
          </div>
        </div>
        <div *ngIf="isUploadDocumentToWorkflow">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text"><i class="fa fa-code-branch" aria-hidden="true"></i></div>
              </div>
              <select id="workflow"
                      class="form-control"
                      formControlName="workflows"
                      [(ngModel)]="workflowIdSelected"
                      (ngModelChange)="reloadDocuments2()">
                <option *ngFor="let workflow of workflows2Upload"
                        [ngValue]="workflow.id">{{workflow.description | translate}}</option>
              </select>
            </div>
          </div>
          <div class="form-row mt-0 form-group">
            <div class="col-md-4">
              <label>{{ 'MESSAGE.ENTER-PASSWORD' | translate }}</label>
            </div>
            <div class="col-md-8">
              <input id="password"
                     class="form-control"
                     type="text"
                     [attr.disabled]="disableOnWorkflowIncorrect ? '' : null"
                     placeholder="{{ 'MESSAGE.ENTER-PASSWORD' | translate }}..."
                     formControlName="password2Upload"
                     [class.is-invalid]="isInvalidControl('password2Upload')">
              <small *ngIf="isInvalidControl('password2Upload')"
                     class="text-danger">
                {{ "MESSAGE.ENTER-PASSWORD" | translate }}
              </small>
            </div>
          </div>
          <div class="form-row mt-0">
            <div class="offset-md-4">
              <button type="button" class="btn btn-outline-success mw-180 font-weight-bold custom-button"
                      [disabled]="disableOnWorkflowIncorrect"
                      (click)="validate()">
                <i class="fa fa-bookmark"></i> {{ "BUTTON.VALIDATE" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="form-row mt-0" *ngIf="isSignatureWorkflowType">
          <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
            <input type="checkbox"
                   class="custom-control-input"
                   id="sequentialNumber"
                   formControlName="sequentialNumber"
                   [(ngModel)]="checkedSequentialNumber"
                   (ngModelChange)="addSequentialNumberWorkflow($event)">
            <label class="custom-control-label"
                   for="sequentialNumber"
                   [ngbTooltip]="tipReceiveDocumentFromFinishedWorkflowChecked">
              {{ "MESSAGE.SEQUENTIAL-NUMBER" | translate }}</label>
          </div>
        </div>
        <div *ngIf="isSequentialNumberWorkflow">
          <div class="form-row mt-0 form-group">
            <div class="col-md-4">
              <label>{{ 'MESSAGE.ENTER-SEQUENTIAL-NUMBER' | translate }}</label>
            </div>
            <div class="col-md-8">
              <input id="sequentialNumberWorkflow"
                     class="form-control"
                     type="text"
                     placeholder="{{ 'MESSAGE.ENTER-SEQUENTIAL-NUMBER' | translate }}..."
                     formControlName="sequentialNumberWorkflow"
                     [class.is-invalid]="isInvalidControl('sequentialNumberWorkflow')">
              <small *ngIf="isInvalidControl('sequentialNumberWorkflow')"
                     class="text-danger">
                {{ "MESSAGE.ENTER-SEQUENTIAL-NUMBER" | translate }}
              </small>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="form-row mt-0" *ngIf="isSignatureWorkflowType && !isUploadInBatch">
          <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
            <input type="checkbox"
                   class="custom-control-input"
                   id="receiveDocumentFromFinishedWorkflow"
                   formControlName="receiveDocumentFromFinishedWorkflow"
                   [(ngModel)]="checkedReceiveDocumentFromFinishedWorkflow"
                   (ngModelChange)="addReceiveDocumentFromFinishedWorkflow($event)">
            <label class="custom-control-label"
                   for="receiveDocumentFromFinishedWorkflow"
                   [ngbTooltip]="tipReceiveDocumentFromFinishedWorkflowChecked">
              {{ "MESSAGE.RECEIVE-DOCUMENTO" | translate }}</label>
          </div>
        </div>
        <div *ngIf="isReceiveDocumentFromFinishedWorkflow">
          <div class="form-row mt-0 form-group">
            <div class="col-md-4">
              <label>{{ 'MESSAGE.ENTER-PASSWORD' | translate }}</label>
            </div>
            <div class="col-md-8">
              <input id="password1"
                     class="form-control"
                     type="text"
                     placeholder="{{ 'MESSAGE.ENTER-PASSWORD' | translate }}..."
                     formControlName="passwordWorkflow"
                     [class.is-invalid]="isInvalidControl('passwordWorkflow')">
              <small *ngIf="isInvalidControl('passwordWorkflow')"
                     class="text-danger">
                {{ "MESSAGE.ENTER-PASSWORD" | translate }}
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row mt-0"
           *ngIf="!isUploadWorkflowType && !isNotcerWorkflowType && hasAuthority('own:view:workflow:10204')">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="minParticipantsCheck"
                 formControlName="minParticipants"
                 [(ngModel)]="checkedMinParticipants"
                 (ngModelChange)="onMinParticipantsToFinalize($event)"
                 [attr.disabled]="SNWithTemplateWorkflowType ? '' : null">
          <label class="custom-control-label"
                 for="minParticipantsCheck"
                 [ngbTooltip]="tipMin">
            {{ "MESSAGE.ASSIGN-MINIMUM-NUMBER-PARTICIPANTS" | translate }}</label>
        </div>
        <div class="form-group col-md-3 mt-2">
          <input id="minParticipantsTofinalize"
                 class="form-control"
                 type="number"
                 [(ngModel)]="workflow.minParticipantsToFinalize"
                 formControlName="minParticipantsToFinalize"
                 [attr.disabled]="selectedMinParticipantsToFinalize ? '' : null"
                 [class.is-invalid]="isInvalidControl('minParticipantsToFinalize')">
          <small *ngIf="isInvalidControl('minParticipantsToFinalize')"
                 class="text-danger">
            {{ "MESSAGE.ENTER-MINIMUM-NUMBER-PARTICIPANTS" | translate }}
          </small>
        </div>
      </div>
      <div class="form-row mt-0"
           *ngIf="!isUploadWorkflowType && !isNotcerWorkflowType && hasAuthority('own:view:workflow:10204')  &&  checkedSignFreely">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="minParticipantsReviewCheck"
                 formControlName="minReviewToFinalizeChecked"
                 [(ngModel)]="checkedMinReviewParticipants"
                 (ngModelChange)="onMinReviewParticipantsToFinalize($event)"
                 [attr.disabled]="SNWithTemplateWorkflowType ? '' : null">
          <label class="custom-control-label"
                 for="minParticipantsReviewCheck"
                 [ngbTooltip]="tipMinReviewToFinalize">
            {{ "MESSAGE.ASSIGN-MINIMUM-NUMBER-REVIEW-PARTICIPANTS" | translate }}</label>
        </div>
        <div class="form-group col-md-3">
          <input id="minReviewToFinalize"
                 class="form-control"
                 type="number"
                 formControlName="minReviewToFinalize"
                 [attr.disabled]="selectedMinReviewParticipantsToFinalize ? '' : null"
                 [class.is-invalid]="isInvalidControl('minReviewToFinalize')">
          <small *ngIf="isInvalidControl('minReviewToFinalize')"
                 class="text-danger">
            {{ "MESSAGE.ENTER-MINIMUM-NUMBER-PARTICIPANTS" | translate }}
          </small>
        </div>
      </div>
      <div class="form-row mt-0"
           *ngIf="!isUploadWorkflowType && !isNotcerWorkflowType && hasAuthority('own:view:workflow:10204') &&  checkedSignFreely">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="minParticipantsSignerCheck"
                 formControlName="minSignerToFinalizeChecked"
                 [(ngModel)]="checkedMinSignerParticipants"
                 (ngModelChange)="onMinSignerParticipantsToFinalize($event)"
                 [attr.disabled]="SNWithTemplateWorkflowType ? '' : null">
          <label class="custom-control-label"
                 for="minParticipantsSignerCheck"
                 [ngbTooltip]="tipMinSignerToFinalize">
            {{ "MESSAGE.ASSIGN-MINIMUM-NUMBER-SIGNER-PARTICIPANTS" | translate }}</label>
        </div>
        <div class="form-group col-md-3">
          <input id="minSignerParticipants"
                 class="form-control"
                 type="number"
                 formControlName="minSignerToFinalize"
                 [attr.disabled]="selectedMinSignerParticipantsToFinalize ? '' : null"
                 [class.is-invalid]="isInvalidControl('minSignerToFinalize')">
          <small *ngIf="isInvalidControl('minSignerToFinalize')"
                 class="text-danger">
            {{ "MESSAGE.ENTER-MINIMUM-NUMBER-PARTICIPANTS" | translate }}
          </small>
        </div>
      </div>
      <div class="form-row mt-0"
           *ngIf="!isUploadWorkflowType && !isNotcerWorkflowType && hasAuthority('own:view:workflow:10204') &&  checkedSignFreely">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="checkedNotifyAttachToReviewers"
                 formControlName="checkedNotifyAttachToReviewers"
                 (ngModelChange)="onNotifyAttachToReviewersAndAssist($event)"
                 [attr.disabled]="SNWithTemplateWorkflowType ? '' : null">
          <label class="custom-control-label"
                 for="checkedNotifyAttachToReviewers"
                 [ngbTooltip]="tipMinReviewToFinalize">
            {{ "MESSAGE.ALERTING-THE-UPLOADER-REVIEWERS-WHEN-DOCUMENT-FINISHED" | translate }}</label>
        </div>
      </div>
      <div class="form-row mt-2" *ngIf="hasDeliverOption || hasRole(ROLE_SUPERADMIN)">
        <div class="form-group col-md-9">
          <label for="deliverCheckbox">{{ "MESSAGE.SEND-DOCUMENTS-TO-REST" | translate }}</label>
          <div class="custom-control custom-checkbox my-1 mr-sm-2">
            <input type="checkbox"
                   class="custom-control-input"
                   id="deliverCheckbox"
                   formControlName="deliver"
                   [(ngModel)]="workflow.deliver"
                   (ngModelChange)="onDeliverChange($event)">
            <label class="custom-control-label" for="deliverCheckbox">{{ "LABEL.YES" | translate }}</label>
          </div>
        </div>
        <div class="form-group col-md-3">
          <label for="code">{{ "LABEL.CODE" | translate }}</label>
          <input type="text"
                 id="code"
                 class="form-control"
                 [(ngModel)]="workflow.code"
                 formControlName="code"
                 [class.is-invalid]="isInvalidControl('code')">
          <small *ngIf="isInvalidControl('code')"
                 class="text-danger">
            {{ "MESSAGE.ENTER-CODE" | translate }}
          </small>
        </div>
      </div>
      <div class="form-row mt-0" *ngIf="isUploadWorkflowType">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="notificateAfterUploadCheck"
                 formControlName="notificateAfterUpload"
                 [attr.disabled]="isChecked('send2Visualization') ? '' : null">
          <label class="custom-control-label"
                 for="notificateAfterUploadCheck"
                 [ngbTooltip]="tipNotificateAfterUpload">
            {{ "MESSAGE.NOTIFY-DOCUMENT-TO-ADDRESS-ASSOCIATED" | translate }}</label>
        </div>
      </div>
      <div class="form-row mt-0" *ngIf="isUploadWorkflowType">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="send2MailAfterUploadCheck"
                 formControlName="send2MailAfterUpload"
                 [attr.disabled]="isChecked('send2Visualization') ? '' : null">
          <label class="custom-control-label"
                 for="send2MailAfterUploadCheck"
                 [ngbTooltip]="tipSend2MailAfterUpload">
            {{ "MESSAGE.NOTIFY-DOCUMENT-TO-ASSOCIATED-EMAIL" | translate }}</label>
        </div>
      </div>
      <div class="form-row mt-0" *ngIf="isNotcerWorkflowType">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="send2VisualizationCheck"
                 formControlName="send2Visualization"
                 [attr.disabled]="isNotcerWorkflowType ? '' : null">
          <label class="custom-control-label"
                 for="send2VisualizationCheck"
                 [ngbTooltip]="tipSend2Visualization">
            {{ "MESSAGE.SEND-DOCUMENT-TO-TEMPORARY-INVITED-TRAY" | translate }}</label>
        </div>
      </div>
      <div class="form-row mt-0" *ngIf="isNotcerWorkflowType && isChecked('send2Visualization')">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="notifyAfterUploadCheck"
                 formControlName="notifyAfterUpload"
                 [attr.disabled]="isChecked('scheduledNotify') ? '' : null">
          <label class="custom-control-label"
                 for="notifyAfterUploadCheck"
                 [ngbTooltip]="tipNotifyAfterUpload">
            {{ "MESSAGE.AUTOMATICALLY-NOTIFY-AFTER-UPLOAD" | translate }}</label>
        </div>
      </div>
      <div class="form-row mt-0" *ngIf="isNotcerWorkflowType">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="scheduledNotify"
                 formControlName="scheduledNotify"
                 [attr.disabled]="isChecked('notifyAfterUpload') ? '' : null">
          <label class="custom-control-label"
                 for="scheduledNotify"
                 [ngbTooltip]="tipScheduledNotify">
            {{ "MESSAGE.USE-SCHEDULED-NOTIFY" | translate }}</label>
        </div>
      </div>
      <div class="form-row mt-0" *ngIf="isUploadWorkflowType || isNotcerWorkflowType">
        <div class="custom-control custom-checkbox my-1 mr-sm-2" style="padding-left: 30px;">
          <input type="checkbox"
                 class="custom-control-input"
                 id="xmlAsDatasourceCheck"
                 formControlName="xmlAsDatasource">
          <label class="custom-control-label"
                 for="xmlAsDatasourceCheck"
                 [ngbTooltip]="tipXMLAsDatasource">
            {{ isUploadWorkflowType ? ('MESSAGE.USE-XML-FILE-AS-DATA-SOURCE' | translate) : ('MESSAGE.USE-XML-FILE-AS-DATA-SOURCE-NOTCER' | translate)}}</label>
        </div>
      </div>
      <div class="form-group" *ngIf="!isNewWorkflow">
        <label for="state">{{"LABEL.STATE" | translate}}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="{{getBgColor(workflow.active)}}">
              <i class="{{getIconOnOrOf(workflow.active)}}"></i></div>
          </div>
          <select id="state"
                  class="form-control"
                  [(ngModel)]="workflow.active"
                  formControlName="state"
                  [class.is-invalid]="isInvalidControl('state')">
            <option [value]="1">{{ "LABEL.ACTIVE" | translate }}</option>
            <option [value]="0">{{ "LABEL.INACTIVE" | translate }}</option>
          </select>
        </div>
      </div>
      <!--      </div>-->
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger"
            (click)="cancel()"><i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
<ng-template
  #tipUploader>{{ "MESSAGE.AT-THE-CONCLUSION-OF-THE-PROCESS-SIGNATURE-REVIEW-SEND-ALERT-BY-EMAIL" | translate }}
  <b>{{ "MESSAGE.THE-UPLOADER-OF-DOCUMENT" | translate }}</b>
</ng-template>
<ng-template #tipDelivery>{{ "MESSAGE.ALLOWS-SELECT" | translate }}
  <b>{{ "MESSAGE.PARTICIPANT-ASSIGNMENT" | translate }}</b>{{ "MESSAGE.MODULE-TO-WHICH-PARTICIPANTS-OF-THE-FLOW-AUTOMATICALLY-SEND-ATTACHMENTS" | translate }}
  <b>{{ "MESSAGE.FINALIZED" | translate }}</b>
  {{ "MESSAGE.STATE-THE-SENDING-WILL-BE-MADE" | translate }}
  <b>{{ "MESSAGE.ELECTRONIC-ADDRESS" | translate }}</b>{{ "MESSAGE.ASSOCIATED-WITH-THEIR-IDENTITY-DOCUMENT" | translate }}
  <b>{{ "MESSAGE.E-MAIL-ADDRESS" | translate }}</b>{{ "MESSAGE.REGISTERED" | translate }}
</ng-template>
<ng-template #tipMin>{{ "MESSAGE.SETS-THE-MINIMUM-NUMBER-OF-SIGNATURES-REVISIONS" | translate }}
  <b>{{ "MESSAGE.FINALIZED" | translate }}</b>
</ng-template>
<ng-template #tipExtractParam>{{ "MESSAGE.EXTRACTS-THE-COORDINATES-OF-THE-UPLOADED-FILE" | translate }}
  <b>{{ "MESSAGE.DOCUMENT-NUMBER" | translate }}</b>{{ "MESSAGE.IN-ORDER-TO-STAMP-THE-RUBRICS-OF-SIGNATURES" | translate }}
</ng-template>
<ng-template #tipNotificateAfterUpload>{{ "MESSAGE.SENDS-THE-DOCUMENT-TO-THE-ASSOCIATE" | translate }}
  <b>{{ "MESSAGE.ELECTRONIC-ADDRESS" | translate }}</b>{{ "MESSAGE.DEFINED-IN-THE-SUBJECT-OF-DOCUMENT" | translate }}
</ng-template>
<ng-template
  #tipSend2MailAfterUpload>{{ "MESSAGE.SEND-THE-DOCUMENT-TO-THE-EMAIL-WHEN-PROCESS-HAS-BEEN-COMPLETE" | translate }}
  <b>{{ "MESSAGE.E-MAIL-ADDRESS" | translate }}</b>{{ "MESSAGE.DEFINED-IN-THE-SUBJECT-OF-DOCUMENT" | translate }}
</ng-template>
<ng-template #tipSend2Visualization>{{ "MESSAGE.SENDS-THE-DOCUMENT-TO-THE-ASSOCIATE-NOTIFY" | translate }}
</ng-template>
<ng-template #tipNotifyAfterUpload>{{ "MESSAGE.NOTIFY-AFTER-UPLOAD" | translate }}
</ng-template>
<ng-template #tipScheduledNotify>{{ "MESSAGE.SCHEDULED-NOTIFY" | translate }}
</ng-template>
<ng-template #tipXMLAsDatasource>{{ "MESSAGE.USES-AS-DATA-SOURCE-A-FILE" | translate }}
  <b>{{ isUploadWorkflowType ? ('MESSAGE.XML' | translate) : ('MESSAGE.XML-EXCEL' | translate)}}</b>{{ "MESSAGE.TO-GENERATE-PDF-FILES" | translate }}
</ng-template>
<ng-template #tipManegeDocumentChecked>{{ "MESSAGE.MANAGEMENT-DOCUMENT-TO-VALIDITY-OR-RENEWAL" | translate }}
</ng-template>
<ng-template #tipCancellationAlertReviewerChecked>{{ "MESSAGE.CANCELLATION-ALERT-FOR-REVIEWERS" | translate }}
</ng-template>
<ng-template #tipDocumentSelection2SignChecked>{{ "MESSAGE.DOCUMENT-SELECTION-2-SIGN" | translate }}
</ng-template>
<ng-template #tipUploadDocument2workflowChecked>{{ "MESSAGE.UPLOAD-DOCUMENT-2-WORKFLOW-AFTER-FINALIZE" | translate }}
</ng-template>
<ng-template #tipCertifyDocumentChecked>{{ "MESSAGE.CERTIFY-DOCUMENT-TIP" | translate }}
</ng-template>
<ng-template #tipCheckGetExternalDocument>{{ "MESSAGE.GET-EXTERNAL-DOCUMENT" | translate }}
</ng-template>
<ng-template
  #tipReceiveDocumentFromFinishedWorkflowChecked>{{ "MESSAGE.RECEIVE-DOCUMENT-FROM-FINISHED-WORKFLOW" | translate }}
</ng-template>
<ng-template #tipMinSignerToFinalize>{{ "MESSAGE.SETS-THE-MINIMUM-NUMBER-OF-SIGNATURES" | translate }}
  <b>{{ "MESSAGE.FINALIZED" | translate }}</b>
</ng-template>

<ng-template #tipMinReviewToFinalize>{{ "MESSAGE.ALERTING-THE-UPLOADER-REVIEWERS-WHEN-DOCUMENT-FINISHED" | translate }}
</ng-template>

<ng-template #tipManifest>{{ "MESSAGE.ADD-MANIFEST-TO-DOCUMENT-FINISHED" | translate }}
</ng-template>
<ng-template #tipTraceability>{{ "MESSAGE.ADD-TRACEABILITY-TO-DOCUMENT-FINISHED" | translate }}
</ng-template>
<ng-template #preventDuplicateSubject>{{ "MESSAGE.DOCUMENT-PREVENT-DUPLICATE-SUBJECT" | translate }}
</ng-template>
